import { render, staticRenderFns } from "./LinkComponent.vue?vue&type=template&id=b539bc50"
import script from "./LinkComponent.vue?vue&type=script&lang=ts"
export * from "./LinkComponent.vue?vue&type=script&lang=ts"
import style0 from "./LinkComponent.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/app/components/base/Icon/Icon.vue').default})
